/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Button, Spin, Table, Popconfirm, Modal } from 'antd'
import { SaveOutlined, ClearOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

import { onListBillItemByCustomerAndProduct } from 'redux/actions'
import { useSelector, useDispatch } from 'react-redux'

import InlineInput from 'components/InlineInput'
import SearchProductVatPopUp from 'components/SearchProductVatPopUp'
import SearchCustomerVatPopUp from 'components/SearchCustomerVatPopUp'
import { handleAlert, addCommas } from 'utils'

// const Search = Input.Search

const DEFAULT_FORM = {
  customer_code: '',
  product_code: '',
  period: 'three_month',
  period_id: 1,
}

const searchTimePeriod = [
  {
    id: 1,
    name: 'ย้อนหลัง 3 เดือน',
    value: 'three_month',
  },
  {
    id: 2,
    name: 'ย้อนหลัง 1 ปี',
    value: 'one_year',
  },
  {
    id: 3,
    name: 'ย้อนหลังทั้งหมด',
    value: 'all',
  },
]

const SalesHistoryPage = () => {
  const columns = [
    {
      title: 'รหัสลูกค้า',
      dataIndex: 'customer_code',
      key: 'customer_code',
      width: '70px',
      sorter: (a, b) => ('' + a.customer_code).localeCompare(b.customer_code),
      sortDirections: ['ascend', 'descend'],
      fixed: 'left',
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: '200px',
      sorter: (a, b) => ('' + a.customer_name).localeCompare(b.customer_name),
      sortDirections: ['ascend', 'descend'],
      fixed: 'left',
    },
    {
      title: 'วันที่ขาย',
      dataIndex: 'bill_date',
      key: 'bill_date',
      width: '70px',
      sorter: (a, b) => ('' + a.bill_date).localeCompare(b.bill_date),
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'เลขที่บิล',
      dataIndex: 'bill_no',
      key: 'bill_no',
      width: '100px',
      render: (text, record) => (
        <Link
          to={`/vat/customer-bill?bill_no=${record.bill_no}`}
          target="_blank"
        >
          {text}
        </Link>
      ),
    },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'product_code',
      key: 'product_code',
      width: '70px',
      sorter: (a, b) => ('' + a.product_code).localeCompare(b.product_code),
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'product_name',
      key: 'product_name',
      width: '300px',
    },
    {
      title: 'ราคาไม่รวมแวต',
      dataIndex: 'price_out',
      key: 'price_out',
      width: '80px',
      render: (text) => (
        <div className="text-align-right pr-2">{addCommas(text)}</div>
      ),
    },
    {
      title: 'ส่วนลด',
      dataIndex: 'discount',
      key: 'discount',
      width: '120px',
      render: (_, record) => {
        return `${Number(record.discount_1)}+${Number(
          record.discount_2
        )}+${Number(record.discount_3)}+${Number(record.discount_4)}`
      },
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
      width: '50px',
    },
    {
      title: 'หน่วย',
      dataIndex: 'unit_name',
      key: 'unit_name',
      width: '50px',
      render: (text) => <div className="text-align-right pr-2">{text}</div>,
    },
  ]
  const [form, setForm] = useState(DEFAULT_FORM)
  const [billList, setBillList] = useState([])
  const [isListLoading, setIsListLoading] = useState(false)
  const [isShowProductPopUp, setIsShowProductPopUp] = useState(false)
  const [isShowCustomerPopUp, setIsShowCustomerPopUp] = useState(false)
  const dispatch = useDispatch()
  const listBillItemByCustomerAndProduct = useSelector(
    (state) => state.listBillItemByCustomerAndProduct
  )

  useEffect(() => {
    document.title = 'ค้นหาประวัติการขายสินค้า'
  }, [])

  useEffect(() => {
    const { loading, data, finished, error, trace } =
      listBillItemByCustomerAndProduct
    setIsListLoading(loading)
    if (!error && finished && !loading) {
      if (data.length === 0) {
        handleAlert('custom', 'ไม่พบรายการนี้ในระบบ')
      }
      setBillList(data)
    }
    if (error && finished && !loading) {
      Modal.error({
        centered: true,
        title: 'ตรวจสอบ',
        content: `${trace.message}`,
      })
    }
  }, [listBillItemByCustomerAndProduct])

  const onSearchProductHandler = (value) => {
    if (value === '') {
      setIsShowProductPopUp(true)
    }
  }

  const onSearchCustomerHandler = (value) => {
    if (value === '') {
      setIsShowCustomerPopUp(true)
    }
  }

  const onSearchHistory = () => {
    const { customer_code, product_code, period_id, period } = form
    if (period_id) {
      dispatch(
        onListBillItemByCustomerAndProduct(customer_code, product_code, period)
      )
    } else {
      handleAlert('custom', 'กรุณาเลือกช่วงเวลาก่อนค้นหา')
    }
  }

  const onChangePeriod = (period_id) => {
    // onChangePeriod
    let id = ''
    let value = ''
    searchTimePeriod.forEach((x) => {
      if (x.id === period_id) {
        id = x.id
        value = x.value
      }
    })
    setForm({
      ...form,
      period_id: id,
      period: value,
    })
  }

  const onCancelProdutPopUp = () => {
    setIsShowProductPopUp(false)
  }

  const onSelectProduct = (data) => {
    setForm({
      ...form,
      product_code: data.code,
    })
    setIsShowProductPopUp(false)
  }

  const onSelectCustomer = (data) => {
    setForm({
      ...form,
      customer_code: data.code,
    })
    setIsShowCustomerPopUp(false)
  }

  const onCancelCustomerPopUp = () => {
    setIsShowCustomerPopUp(false)
  }

  const onClearInput = () => {
    setForm(DEFAULT_FORM)
    setBillList([])
  }

  return (
    <div>
      <SearchCustomerVatPopUp
        visible={isShowCustomerPopUp}
        onCancel={onCancelCustomerPopUp}
        onClick={onSelectCustomer}
      />
      <SearchProductVatPopUp
        visible={isShowProductPopUp}
        onCancel={onCancelProdutPopUp}
        onClick={onSelectProduct}
      />
      {/* <button onClick={() => console.log(form)}>Form</button> */}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'inline-block' }}>
          <h1>ค้นหาประวัติการขายสินค้า</h1>
        </div>
        <div style={{ display: 'inline-block' }}>
          <Popconfirm
            title="คุณต้องการล้างหน้าจอใช่หรือไม่ ?"
            okText="ใช่"
            cancelText="ยกเลิก"
            onConfirm={onClearInput}
          >
            <Button
              type="default"
              danger
              icon={<ClearOutlined />}
              size="large"
              block
            >
              ล้างหน้าจอ
            </Button>
          </Popconfirm>
        </div>
      </div>
      <div className="form-wrapper-vat" style={{ paddingBottom: '10px' }}>
        <div className="input-wrapper">
          <div className="input-item">
            <InlineInput
              onSearch={(value) => {
                onSearchCustomerHandler(value)
              }}
              inputOption="search"
              label="รหัสลูกค้า"
              placeholder="รหัสลูกค้า"
              value={form.customer_code}
              onChange={(event) => {
                setForm({
                  ...form,
                  customer_code: event.target.value.toUpperCase(),
                })
              }}
            />
          </div>
          <div className="input-item">
            <InlineInput
              label="ช่วงเวลาในการค้นหา"
              placeholder="เลือกช่วงเวลา"
              required
              value={form.period_id}
              onChange={(period_id) => {
                onChangePeriod(period_id)
              }}
              width="200px"
              inputOption="select_input"
              options={searchTimePeriod}
            />
          </div>
        </div>
        <div className="input-wrapper">
          <div className="input-item">
            <InlineInput
              onSearch={(value) => {
                onSearchProductHandler(value)
              }}
              inputOption="search"
              label="รหัสสินค้า"
              placeholder="รหัสสินค้า"
              value={form.product_code}
              onChange={(event) => {
                setForm({
                  ...form,
                  product_code: event.target.value.toUpperCase(),
                })
              }}
            />
          </div>
          <div
            className="input-item"
            style={{ marginLeft: '20px', width: '180px' }}
          >
            <Button
              type="primary"
              icon={<SaveOutlined />}
              size="large"
              onClick={onSearchHistory}
              block
            >
              ค้นหา
            </Button>
          </div>
        </div>
      </div>
      <Spin spinning={isListLoading}>
        <div style={{ marginTop: '10px' }}>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={billList}
            size="small"
            scroll={{ x: 1500, y: 680 }}
            style={{ height: '685px' }}
            pagination={{
              simple: true,
              position: ['bottomRight'],
              defaultPageSize: 20,
              showSizeChanger: true,
            }}
          />
        </div>
      </Spin>
    </div>
  )
}

export default SalesHistoryPage
